











































import {
  faCamera,
  faMap,
  faStreetView
} from '@fortawesome/free-solid-svg-icons'
import { Classified } from '~/models/classified/types'
import { faYoutube } from '@fortawesome/free-brands-svg-icons'
import { mapGetters, mapMutations, mapState } from 'vuex'
import { CLASSIFIED_VIEW_NS } from '~/store/modules/shared/classifieds/view/state'
import {
  SET_BIG_PHOTOS_VISIBLE,
  SET_YOUTUBE_VISIBLE
} from '~/store/modules/shared/classifieds/view/mutation-types'
import { ci360Logo } from '~/icons/source/solid/360logo'
import { defineComponent, PropType } from '@nuxtjs/composition-api'

export default defineComponent({
  props: {
    classified: {
      type: Object as PropType<Classified>,
      required: true
    }
  },
  data() {
    return {}
  },
  computed: {
    ...mapState(CLASSIFIED_VIEW_NS, {
      youtubeVisible: state => state.youtubeVisible
    }),
    ...mapGetters(CLASSIFIED_VIEW_NS, {
      isMapVariant: 'isMapVariant',
      classifiedHasPanoramicPhotos: 'classifiedHasPanoramicPhotos'
    }),
    icons() {
      return {
        map: faMap,
        streetView: faStreetView,
        youtube: faYoutube,
        camera: faCamera,
        logo360: ci360Logo
      }
    },
    streetViewLink(): string | null {
      if (this.classified?.location?.geolocation) {
        const geolocation = Object.values(
          this.classified.location.geolocation
        ).join(',')
        return `https://www.google.com/maps/@?api=1&map_action=pano&viewpoint=${geolocation}&heading=-45&pitch=38&fov=80`
      }

      return null
    },
    hasYoutube() {
      return this.classified.videos?.length
    },
    hasPhotos() {
      const compactPhotos = this.classified.compactPhotos
      return (
        compactPhotos.native.photos.length ||
        compactPhotos.userPhotos.photos.length ||
        compactPhotos.knowledgebasePhotos.photos.length
      )
    }
  },
  methods: {
    ...mapMutations(CLASSIFIED_VIEW_NS, {
      setBigPhotosVisible: SET_BIG_PHOTOS_VISIBLE,
      setYoutubeVisible: SET_YOUTUBE_VISIBLE
    }),
    showMap() {
      const id = 'location-map'
      const element = document.getElementById(id)

      if (element) {
        if (!this.isMapVariant) {
          // window is not the scrollbar container
          element.scrollIntoView({ behavior: 'smooth' })
        } else {
          const yOffset =
            -document.getElementById('header-section').offsetHeight || -40
          const y =
            element.getBoundingClientRect().top + window.pageYOffset + yOffset

          window.scrollTo({ top: y, behavior: 'smooth' })
        }
      }
    },
    youtubeClicked() {
      this.setYoutubeVisible(true)
    },
    mainImagesClicked() {
      if (this.youtubeVisible) {
        this.setYoutubeVisible(false)
      } else {
        this.setBigPhotosVisible(true)
      }
    },
    show360() {
      this.setBigPhotosVisible('360')
    }
  }
})
